import * as React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';

import { StoreStatus } from 'components/store-status';

import { StoreCardCaption } from './components';
import { HalalContainer } from './store-card.styled';
import { StoreDetails } from './types';

interface StoreCaptionProps {
  storeDetails: StoreDetails;
}

export const StoreCaption: React.FC<StoreCaptionProps> = ({ storeDetails }) => {
  const { formatMessage } = useIntl();

  const dateNow = new Date(Date.now());

  const { openingHours, closingHours, yesterdayClosingHours, yesterdayOpeningHours } =
    storeDetails.operatingHours || {};

  return (
    <StoreCardCaption
      prefix={storeDetails.distanceText}
      suffix={
        <span>
          {storeDetails.isHalal && (
            <>
              <HalalContainer>
                <Icon
                  icon="halal"
                  color="icon-default"
                  title={formatMessage({ id: 'isHalalTitle' })}
                />
              </HalalContainer>
              <span role="separator"> &bull; </span>
            </>
          )}
          <StoreStatus
            openingHours={openingHours}
            closingHours={closingHours}
            yesterdayClosingHours={yesterdayClosingHours}
            yesterdayOpeningHours={yesterdayOpeningHours}
            dateNow={dateNow}
          />
        </span>
      }
    />
  );
};
